(function (angular) {
    'use strict';

    /**
     * Requires directives:
     *   * has-any-authority-or-state
     *   * uib-dropdown-toggle
     */
    angular
        .module('app')
        .component('miMenuBidiso', {
            bindings: {
                menu: '<',
                navCollapsed: '<',
                lateral: '<'
            },
            templateUrl: 'app/components/menu/menu-bidiso.html',
            /* @ngInject */
            controller: function ($state) {
                var vm = this;

                vm.checkActiveStates = function (activeStates) {
                    var active = false;
                    if (activeStates) {
                        var states = activeStates.replace(/\s+/g, '').split(',');
                        states.forEach(function (state) {
                            if ($state.includes(state) || state === 'lugares') {
                                active = true;
                            }
                        });
                    }
                    return active;
                };
            }
        });
})(angular);
